// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pVlE","left":"styles_left__2paA1","desktopActions":"styles_desktopActions__3SSEa","title":"styles_title__3gLcP"};